import { createFileRoute } from "@tanstack/react-router";
import { DealsWithUnits } from "@/components/DealsWithUnits";

export const Route = createFileRoute("/_authenticated/deals-with-units/")({
  component: DealsWithUnits,
  staticData: { page: "deals" },
});
